import FinanceXRules from './FinanceXRules.container';

export default FinanceXRules;
